<template>
  <img
    class="img-fluid"
    :src="require('../../static/GDQ-Associates-White.png')"
  >
</template>
<script>
export default {
  data () {
    return {
    }
  }
}
</script>
<style>
</style>
